import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };

type State = { error: Error | null; errorInfo: ErrorInfo | null };

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, errorInfo: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-neutral-100 p-6">
          <div className="max-w-lg w-full bg-white rounded-xl shadow-lg border border-red-100 p-6 text-left">
            <h1 className="text-lg font-bold text-red-700 mb-2">Algo falló al cargar la aplicación</h1>
            <p className="text-sm text-neutral-600 mb-4">
              Abrí las herramientas de desarrollo (F12) → pestaña Consola / Red y comprobá si algún archivo{' '}
              <code className="bg-neutral-100 px-1 rounded">.js</code> da 404.
            </p>
            <pre className="text-xs bg-neutral-900 text-red-200 p-3 rounded-lg overflow-auto max-h-48 whitespace-pre-wrap break-all">
              {this.state.error?.message}
              {this.state.errorInfo?.componentStack ? `\n\n${this.state.errorInfo.componentStack}` : ''}
            </pre>
            <button
              type="button"
              className="mt-4 w-full py-2.5 rounded-lg bg-cysol-red text-white text-sm font-semibold"
              onClick={() => window.location.reload()}
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
